export const GETTING_STARTED_STEPS = [
  {
    stepKey: "create-account",
    title: "Create account",
    label: "Free and unlimited use.",
    modalTitle: "Create account",
    buttonText: "Create account",
    video: "https://d2gfhx6otln0v7.cloudfront.net/media/files/getting-started_1_create_account.mp4"
  },
  {
    stepKey: "search",
    title: "Search",
    label: "Powerful search. 1250 spaces.",
    modalTitle: "Learn how to run powerful searches and instantly refine and sort your results",
    buttonText: "Search for space",
    video: "https://d2gfhx6otln0v7.cloudfront.net/media/files/getting-started_2_search.mp4",
  },
  {
    stepKey: "create-campaign",
    title: "Create campaign",
    label: "Deploy unrivalled planning tools.",
    modalTitle: "Learn how to create a campaign - the foundation for planning your activation",
    buttonText: "Create campaign",
    video: "https://d2gfhx6otln0v7.cloudfront.net/media/files/getting-started_3_planning_and_booking_campaigns.mp4"
  },
  {
    stepKey: "add-space",
    title: "Add space to campaign",
    label: "Curate your perfect spaces.",
    modalTitle: "Learn how to move spaces into your campaign so you can check availabilty, assess mutliple date options and more!",
    modalHint: "You can add a space to your campaign by clicking the heart icon on any of your desired space page",
    buttonText: "Search and add spaces",
    video: "https://d2gfhx6otln0v7.cloudfront.net/media/files/getting-started_4_add_space_to_campaign.mp4"
  },
  {
    stepKey: "option-book",
    title: "Option or book",
    label: "Reserve and book directly.",
    modalTitle: "Learn how to book or option spaces now",
    modalHint: "To book or option, first add some dates or make an enquiry about a space you have added to a campaign",
    buttonText: "Option and book",
    video: "https://d2gfhx6otln0v7.cloudfront.net/media/files/getting-started_5_option_or_book.mp4"
  }
];
